(function() {

    'use strict';

    angular.module('app').config(dashboardUrlConfig);

    dashboardUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function dashboardUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/compliance/add', {
            templateUrl: '/templates/pages/compliance/complianceDetails.html',
            controller: 'ComplianceDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'compliance',
                htmlTitle: 'Compliance Details',
                pageTitle: 'Compliance Details',
                name: 'complianceDetails'
            }
        }).when('/compliance/details/:id', {
            templateUrl: '/templates/pages/compliance/complianceDetails.html',
            controller: 'ComplianceDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'compliance',
                htmlTitle: 'Compliance Details',
                pageTitle: 'Compliance Details',
                name: 'complianceDetails'
            }
        });

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();



// WEBPACK FOOTER //
// ./js/urls/compliance.js